import { queue } from './queue';

function openModal(component, props) {
  return queue.push(component, props);
}

export { openModal };
